module.exports = __webpack_public_path__ + "img/transfer.0ebc9fbf.svg";